export default __webpack_public_path__ + "static/media/Rectangle_93.b9563441.png";